import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import styledComponent from 'styled-components';
import { colors } from 'styles/styleVariables';

export const WorkExperienceGridStyles = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: `1px solid ${theme.palette.system.borderColor}`,
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: `1px solid ${theme.palette.system.borderColor}`,
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
  tooltipText: {
    maxWidth: '300px',
  },
  isErrorCell: {
    border: '1px solid !important',
    borderRadius: '4px',
    borderColor: 'red',
    color: 'red',
    backgroundColor: `rgb(126,10,15,0.1)`,
  },
}));

export const ClickableLink = styledComponent.div`
  color: ${colors.amnBlue};
  cursor: pointer;
  font-size: 12px;
  font-weight: initial;
`;

interface IStyleProps {
  columnWidth?: string;
  removeCloseIcon?: boolean;
}

export const gridTypeAheadCellStyles = makeStyles<IStyleProps>()((theme: Theme, { columnWidth, removeCloseIcon }) => ({
  typeAheadCellWrapper: {
    width: '100%',
  },
  typeAheadCellInput: {
    paddingRight: `${removeCloseIcon ? theme.spacing(4) : theme.spacing(7.5)} !important`,
    paddingLeft: theme.spacing(1),
  },
  typeAheadCellPopper: {
    width: 'auto !important',
    minWidth: columnWidth || 'auto',
  },
}));
